<template>
    <div class="ld-panel-title">
		<router-link to="/hosts" class="back-btn"><span></span>操作审计</router-link>
	</div>
	<div class="ld-panel-main">
		<div class="search-main clear">
			<el-input v-model="searchInput" class="input" placeholder="请输入搜索内容..." clearable @clear="handleEmpty"></el-input>
			<span @click="searchClick" class="btn"></span>
		</div>
		<el-table :data="tableData" v-loading="loading" style="width: 100%">
			<el-table-column prop="user_name" label="用户名" width="180" />
			<el-table-column label="实例 ID(名称)">
				<template #default="scope">
					<span class="instance_name">{{scope.row.instance_id}}</span>
					<span v-if="scope.row.instance_name">({{scope.row.instance_name}})</span>
				</template>
			</el-table-column>
			<el-table-column prop="detail" label="操作内容" />
			<el-table-column prop="update_time" label="操作时间" />
		</el-table>
		<pageList :pagination="pagination" :paginationTotal="paginationTotal" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"></pageList>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted } from 'vue';
	import { operation } from '@/api/host';
	import pageList from '../../components/pageList.vue'
	
	const pagination = reactive({page: 1,size: 15});
	const paginationTotal = ref(0);
	const loading = ref(true);
	const searchInput = ref('');
	const tableData = ref();

	const fetchListF = () => {
		const param = {
			'page':pagination.page,
			'size':pagination.size,
			'search':searchInput.value
		}
		operation(param).then((res) => {
			paginationTotal.value = res.data.count
			tableData.value = res.data.list
			loading.value = false
		})
	}
	const handleCurrentChange = (e) => {
		pagination.page = e;
		fetchListF();
	};
	const handleSizeChange = (e) => {
		pagination.size = e;
		fetchListF();
	};
	const searchClick = () => {
		fetchListF()
	};
	const handleEmpty = () => {
		fetchListF()
	};
	
	onMounted(() => {
		fetchListF()
	});
			
</script>

<style lang="scss" scoped>
	.search-main{float: right;}
</style>